/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r=r=>Array.isArray(r)&&"number"==typeof r[0];export{r as isBezierDefinition};
//# sourceMappingURL=is-bezier-definition.js.map
